module.exports = __webpack_public_path__ + "img/new-landing-bottoming.45fd109f.png";